import React from 'react';
import { Flower2Icon, FlowerIcon, GiftIcon, PartyPopperIcon, SparklesIcon } from 'lucide-react';
import { BalloonIcon } from './BalloonIcon';
import type { ServiceIcon } from '../../data/site';
const map: Record<ServiceIcon, React.ComponentType<{
  className?: string;
}>> = {
  bouquet: FlowerIcon,
  balloon: BalloonIcon,
  centerpiece: SparklesIcon,
  theme: PartyPopperIcon,
  arrangement: Flower2Icon,
  combo: GiftIcon
};
export function ServiceGlyph({
  icon,
  className
}: {
  icon: ServiceIcon;
  className?: string;
}) {
  const Icon = map[icon];
  return <Icon className={className} aria-hidden="true" data-id="element-396" data-mp="3g1yjtdpcet7v" />;
}